import axios from 'axios'
const baseUrl = 'api/ip-metrics'

export function getIpMetricBins() {
    return axios.get(`${baseUrl}/bins`)
}
